module.exports = __webpack_public_path__ + "img/shop.f6a53f91.png";